import { Copy, ExternalLink, MessageSquare } from "lucide-react";
import type { ChatMessage } from "@/lib/chatConnect";

/** Glyph plus the Slack reaction name reactions.add expects. */
export const QUICK_REACTIONS: { emoji: string; name: string }[] = [
  { emoji: "✅", name: "white_check_mark" },
  { emoji: "👀", name: "eyes" },
  { emoji: "👍", name: "+1" },
  { emoji: "❤️", name: "heart" },
  { emoji: "🙌", name: "raised_hands" },
  { emoji: "😂", name: "joy" },
  { emoji: "🎉", name: "tada" },
];

type Props = {
  message: ChatMessage;
  onClose: () => void;
  /** Only when the account can really react (Slack reactions:write). */
  onReact?: (message: ChatMessage, name: string) => void;
  /** Only when the account can open threads in Hub. */
  onReply?: (message: ChatMessage) => void;
  onCopy: (message: ChatMessage) => void;
  /** Only when the provider gives a permalink (Slack). */
  onOpenInProvider?: (message: ChatMessage) => void;
  providerLabel?: string;
};

export function ChatMessageMenu({ message, onClose, onReact, onReply, onCopy, onOpenInProvider, providerLabel }: Props) {
  return (
    <div className="chat-menu-scrim" role="presentation" onClick={onClose}>
      <div
        className="chat-menu"
        role="dialog"
        aria-label="Message actions"
        onClick={(event) => event.stopPropagation()}
      >
        {onReact ? (
          <div className="chat-menu-emojis" role="list">
            {QUICK_REACTIONS.map((reaction) => (
              <button
                key={reaction.name}
                type="button"
                className="chat-menu-emoji"
                aria-label={`React with :${reaction.name}:`}
                onClick={() => onReact(message, reaction.name)}
              >
                {reaction.emoji}
              </button>
            ))}
          </div>
        ) : null}
        <ul className="chat-menu-list">
          {onReply ? (
            <li>
              <button type="button" onClick={() => onReply(message)}>
                <MessageSquare size={16} /> Reply in thread
              </button>
            </li>
          ) : null}
          <li>
            <button type="button" onClick={() => onCopy(message)}>
              <Copy size={16} /> Copy message
            </button>
          </li>
          {onOpenInProvider ? (
            <li>
              <button type="button" onClick={() => onOpenInProvider(message)}>
                <ExternalLink size={16} /> Open in {providerLabel || "Slack"}
              </button>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
}
